import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';
import { LoginFormService } from 'src/app/modules/main/components/login-form/login-form.service';
import { SearchObject, SearchObjectService } from 'src/app/shared/services/search-object.service';
import { SearchOptionTypes } from 'src/app/shared/models/FIlterTerms';
import { LoadingScreenService } from 'src/app/shared/components/loading-screen/loading-screen.service';

@Component({
  selector: 'app-redirect-search',
  templateUrl: './redirect-search.component.html',
  styleUrls: ['./redirect-search.component.scss'],
  standalone: true,
  imports: []
})
export class RedirectSearchComponent implements OnInit {
  private _queryParamMap;
  redirectSearchErrorMsg: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private userRulesService: UserRulesService,
    private loginFormService: LoginFormService,
    private searchObjectService: SearchObjectService,
    private loadingScreenService: LoadingScreenService) {
  }

  ngOnInit() {
    this.redirectSearchErrorMsg = '';
    this.loadingScreenService.toggleLoaderOn();
    this._queryParamMap = null;
    if (this.activatedRoute.snapshot.queryParamMap.keys.length > 0) {
      this._queryParamMap = this.activatedRoute.snapshot.queryParamMap;
    }

    this.userRulesService.checkLogin(false).subscribe(loggedIn => {
      if (loggedIn) {
        let primaryId = this.userRulesService.getPrimaryId();
        this.getMemberDetails(primaryId);
        this.getMemberNetwork(this.userRulesService.getSecondaryId(), this.userRulesService.getTPAClientIdentifier());
      } else {
        // TODO Show Error Message
        this.loadingScreenService.toggleLoaderOff();
        this.redirectSearchErrorMsg = 'Error loading values. Please try again.';
      }
    });
  }

  private getMemberNetwork(id: string, tpaClientIdentifier?: string) {
    this.redirectSearchErrorMsg = '';
    this.loginFormService.getMemberNetwork(id, tpaClientIdentifier).subscribe(data => {
      if (data && data.networks && data.networks.length !== 0) {
        this.searchObjectService.setLoggedIn(true);
        this.searchObjectService.setCareTypes(data.networks);
        if (this._queryParamMap.get('caretype')) {
          let selectedNetwork = data.networks.find(n => n.careType.toLowerCase() === this._queryParamMap.get('caretype').toLowerCase());
          if (selectedNetwork) {
            this.setSearchObject(selectedNetwork);

          }
        }
      }
      this.loadingScreenService.toggleLoaderOff();
    },
      error => {
        // TODO Show Error Message
        this.loadingScreenService.toggleLoaderOff();
        this.redirectSearchErrorMsg = 'Error loading values. Please try again.';
      });
  }
  private getMemberDetails(memberId: string) {
    this.loginFormService.getMemberDetails(memberId).subscribe(data => {
      this.searchObjectService.setMemberData(data);
      this.loadingScreenService.toggleLoaderOff();
    },
    error => {
      // TODO Show Error Message
      this.loadingScreenService.toggleLoaderOff();
      this.redirectSearchErrorMsg = 'Error loading values. Please try again.';
    });
  }

  private setSearchObject(selectedNetwork) {
    const searchObject: SearchObject = this.searchObjectService.getSearchObject();
    searchObject.careType = this._queryParamMap.get('caretype');
    searchObject.specialty = this._queryParamMap.get('specialty');
    searchObject.providerType = this._queryParamMap.get('providertype');
    if (searchObject.specialty || searchObject.providerType) searchObject.searchOption = SearchOptionTypes.specialty;

    searchObject.address = this._queryParamMap.get('address');
    searchObject.mileRadius = this._queryParamMap.get('radius') ? this._queryParamMap.get('radius') : '20';
  
    searchObject.networkId = selectedNetwork.networkId;
    searchObject.filters.subProductKey = selectedNetwork.subProductKey;

    this.submitSearchForm(searchObject);
  }

  private submitSearchForm(searchObject: SearchObject) {
    this.searchObjectService.setSearchObject(searchObject);
    this.searchObjectService.setSearchURL(false, true, true);
  }


}
